<nav>
  <div class="navbar h-20 bg-base-100 drop-shadow-lg fixed z-10 p-0">
    <div class="navbar-start h-full lg:mx-10 mx-5">
      <div class="dropdown">
        <div tabindex="0" role="button" class="lg:hidden pr-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h8m-8 6h16" />
          </svg>
        </div>
        <ul
          tabindex="0"
          class="menu menu-lg dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow-lg">
          @if (role === 'admin') {
          <li>
            <a
              name="Users"
              id="navbar-users"
              routerLink="/users"
              [routerLinkActiveOptions]="{ exact: false }"
              routerLinkActive="border-l-8 border-primary"
              >Users</a
            >
          </li>
          }
          <li>
            <a
              name="Candidates"
              id="navbar-candidates"
              routerLink="/candidates"
              [routerLinkActiveOptions]="{ exact: false }"
              routerLinkActive="border-l-8 border-primary"
              >Candidates</a
            >
          </li>
          <li>
            <a
              name="Invitations"
              id="navbar-invitations"
              routerLink="/invitations"
              [routerLinkActiveOptions]="{ exact: false }"
              routerLinkActive="border-l-8 border-primary"
              >Invitations</a
            >
          </li>
          <li>
            <a
              name="Test Sets"
              id="navbar-test-sets"
              routerLink="/test-sets"
              [routerLinkActiveOptions]="{ exact: false }"
              routerLinkActive="border-l-8 border-primary"
              >Test Sets</a
            >
          </li>
          <li>
            <a
              name="Problems"
              id="navbar-problems"
              routerLink="/problems"
              [routerLinkActiveOptions]="{ exact: false }"
              routerLinkActive="border-l-8 border-primary"
              >Problems</a
            >
          </li>
        </ul>
      </div>
      <a
        class="flex items-center font-bold lg:text-3xl text-2xl lg:pr-10"
        routerLink="/">
        <img class="h-10 w-10" src="/myrank_logo_no_text.png" alt="">
        <div class="ml-1">MyRank</div>
      </a>
    </div>
    <div class="navbar-center hidden lg:flex h-full">
      <ul class="menu menu-horizontal text-xl md:font-semibold h-full p-0">
        @if (role === 'admin') {
        <a
          name="Users"
          id="navbar-users"
          class="flex h-full items-center hover:text-primary transition-colors px-6"
          routerLink="/users"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive="border-b-8 border-primary">
          <li>Users</li>
        </a>
        }
        <a
          name="Candidates"
          id="navbar-candidates"
          class="flex h-full items-center hover:text-primary transition-colors px-6"
          routerLink="/candidates"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive="border-b-8 border-primary">
          <li>Candidates</li>
        </a>
        <a
          name="Invitations"
          id="navbar-invitations"
          class="flex h-full items-center hover:text-primary transition-colors px-6"
          routerLink="/invitations"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive="border-b-8 border-primary">
          <li>Invitations</li>
        </a>
        <a
          name="Test Sets"
          id="navbar-test-sets"
          class="flex h-full items-center hover:text-primary transition-colors px-6"
          routerLink="/test-sets"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive="border-b-8 border-primary">
          <li>Test Sets</li>
        </a>
        <a
          name="Problems"
          id="navbar-problems"
          class="flex h-full items-center hover:text-primary transition-colors px-6"
          routerLink="/problems"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive="border-b-8 border-primary">
          <li>Problems</li>
        </a>
      </ul>
    </div>
    <div class="navbar-end items-center lg:mr-10 mr-5">
      <div class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="btn btn-circle size-12">
          <span class="">{{ getUserTwoFirstLetter() }}</span>
        </div>
        <ul
          tabindex="0"
          class="dropdown-content menu items-center bg-base-100 rounded-box z-1 mt-1 p-3 center shadow-sm">
          <li class="font-semibold" data-testid="navbar-role">[{{ getRoleUpperCase() }}]</li>
          <li class="mb-2">{{ email }}</li>
          <div class="h-3 mb-6">
            <app-button
              [color]="'error'"
              [label]="'Logout'"
              [type]="'button'"
              [size]="'small'"
              (clicked)="logout()" />
          </div>
        </ul>
      </div>
    </div>
  </div>
</nav>
